import { render } from "./UiStrMappingReadOnly.pug?vue&type=template&id=a1f2e530&lang=pug"
import script from "./UiStrMappingReadOnly.js?vue&type=script&lang=js"
export * from "./UiStrMappingReadOnly.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__